import { slideoutTemplate } from 'entities/step-groups/templates/modal';
import { augmentedWrap } from './utils';

export const addTheme = (content, selectedVariant, preserveOverrides) =>
  augmentedWrap(content)
    .updateStyle(
      'config.style',
      {
        theme: selectedVariant,
        ...(!preserveOverrides &&
          content.config.slideout &&
          slideoutTemplate.style),
      },
      preserveOverrides
    )
    .value();
